<template>
  <div class="row vh-100 m-0">
    <!-- Left Column -->
    <div
      class="col-12 col-md-7 col-lg-6 d-flex flex-column justify-content-center px-4 px-lg-5"
    >
      <slot />
      
      <footer-component  class="mt-5" show />
    </div>

    <!-- Right Column -->
    <div
      class="col-12 col-md-5 col-lg-6 auth-brand d-none d-md-flex flex-column align-items-center"
    >
      <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
        <img src="img/logo_iusa_w.svg" class="logo-iusa mb-5" alt="IUSA" />
        <img src="/assets/img/logo_employee_portal_login.webp" class="logo-portal" alt="Portal del Empleado" />
      </div>

      <!-- Social Media Links -->
      <social-media-links class="mb-5" />
    </div>
  </div>  
</template>

<script>
import FooterComponent from '@/template/partials/Footer.vue';
import SocialMediaLinks from '@/components/SocialMediaLinks.vue';

export default {
  name: "AuthLayout",

  components: {
    FooterComponent,
    SocialMediaLinks,
  }
};
</script>

<style scoped>
.auth-brand {
  background: url("/assets/img/background_login.webp") bottom left no-repeat;
}
.logo-portal {
  width: 280px;
}
.logo-iusa {
  width: 150px;
}
</style>